import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Icon, Tooltip } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import history from '../../history'
import { withRouter } from 'react-router-dom'
import Loader from '../../util/Loader'
import { actions } from '../../redux/modules/leadFunctions/leadAttachmentActions'
import { filterCaseInsensitive } from '../../util'
import _ from 'lodash'
import { ModalRoute } from 'react-router-modal'
import PropTypes from 'prop-types'

import AddEditFormModal from './components/attachments/AddEditFormModal.component'

import * as authSelectors from '../../selectors/auth'
import * as attachmentsSelectors from '../../selectors/lead/attachments'

const propTypes = {
  leadAttachmentes: PropTypes.any
}

class LeadAttachments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      content: null
    }
  }

  componentDidMount() {
    const { leadId } = this.props
    this.props.leadAttachmentsRefresh({
      leadId: leadId,
      next: (err, payload) => {
        const { attachmentIdParam } = this.props
        if (!err) {
          const results = _.get(payload, 'data')
          const currentLead = _.find(results, { id: attachmentIdParam })
          this.setState({
            currentId: attachmentIdParam,
            content: currentLead
          })
        }
      }
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/attachments/edit/${row.id}`)
    this.setState({
      modalVisible: true,
      currentId: row.id,
      content: row
    })
  }

  handleAddButton = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/attachments/add`)
    this.setState({
      modalVisible: true,
      currentId: 0,
      content: null,
      fileList: []
    })
  }

  handleCancel = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/attachments`)
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleUploadChange = event => {
    console.log('file plesae?', event.target.files)
  }

  render() {
    const { content } = this.state
    const { leadId, attachmentIdParam, leadAttachments } = this.props

    if (!leadAttachments) {
      return <Loader />
    }
    return (
      <div>
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'edit',
            contentData: content,
            handleCancel: this.handleCancel,
            leadId: leadId,
            attachmentIdParam: attachmentIdParam
          }}
          path={`/lead/:leadId/attachments/edit/:attachmentId`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'add',
            handleCancel: this.handleCancel,
            leadId: leadId
          }}
          path={`/lead/:leadId/attachments/add`}
          exact
        />
        <div className="jobsBar">
          Attachments
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addleadLabel">
              ADD Attachment
            </div>
          </div>
        </div>
        {leadAttachments && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header !== undefined) {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={leadAttachments}
            columns={[
              {
                columns: [
                  {
                    Header: 'Filename',
                    id: 'filename',
                    accessor: 'filename',
                    Cell: d => <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>,
                    maxWidth: 350
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Added By',
                    id: 'first_name',
                    accessor: d => d.first_name + ' ' + d.last_name,
                    maxWidth: 150
                  },
                  {
                    Cell: row => (
                      <Tooltip placement="left" title="Open this file on a new window">
                        <a target="_blank" href={row.original.signedUrl}>
                          <Icon type="export" className="fontSize20" />
                        </a>
                      </Tooltip>
                    ),
                    maxWidth: 35
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadAttachmentActions: state.leadAttachmentActions,
  leadAttachments: attachmentsSelectors.getLeadAttachments(state, props),
  user: authSelectors.getUser(state, props),
  attachmentIdParam: attachmentsSelectors.getAttachmentIdParam(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

LeadAttachments.propTypes = propTypes
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LeadAttachments))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadAttachments.container.js